import React from 'react';
import { useNavigate } from 'react-router-dom';

const Register = () => {
  const navigate = useNavigate();

  // Registration is disabled - invite-only system
  React.useEffect(() => {
    navigate('/login');
  }, [navigate]);

  return null;
};

export default Register;
